import s3Client from '@/utils/s3Client'

const prefix = 'uploads'

export default class MediaUploader {
  constructor(client = s3Client) {
    this.client = client
  }

  async upload({ file, key, acl = 'aws-exec-read' }) {
    return new Promise((resolve, reject) => {
      this.client.upload(
        {
          Key: `${prefix}/${key}`,
          Body: file,
          ACL: acl,
        },
        this._handler(resolve, reject)
      )
    })
  }

  _handler(resolve, reject) {
    return (err, data) => {
      if (err) {
        reject(err)
      } else {
        resolve(data)
      }
    }
  }
}
